import store from '../store'
// import base64 from './base64.js'
import ElementUI from "element-ui";
import { timestampToTime } from './filters.js'

let websock = null

let socktimer = null

let userinfo = null

let token = null

let imNettyDomain = null

let websockUrl = null //正式
// let testwebsockUrl = 'ws://172.16.4.134:13088' //本地测试

let errsum = 0; //连接失败次数

function initWebSocket() {
    websock = null
    userinfo = localStorage.getItem('userInfo')
    if (userinfo) {
        userinfo = JSON.parse(userinfo)
        imNettyDomain = userinfo.domainConfig.imNettyDomain
        websockUrl = imNettyDomain
        console.log('正在连接WebSocket')
    }
    if (socktimer) {
        clearInterval(socktimer)
    }
    websock = new WebSocket(websockUrl)
    websock.onmessage = function(e) {
        websocketonmessage(e)
    }
    websock.onclose = function() {
        console.log('WebSocket连接onclose', new Date())
        websocketclose(true)
    }
    websock.onopen = function() {
        websocketOpen()
    }
    // 连接发生错误的回调方法
    websock.onerror = function() {
        console.log('WebSocket连接onerror', new Date())
        websocketclose()
    }
}

// 实际调用的方法
function sendSock(agentData) {

    if (websock.readyState === websock.OPEN) {
        // 若是ws开启状态
        websocketsend(agentData)
    } else if (websock.readyState === websock.CONNECTING) {
        // 若是 正在开启状态，则等待1s后重新调用
        setTimeout(function() {
            sendSock(agentData)
        }, 1000)
    } else {
        websocketclose()
    }
}

// 数据接收
function websocketonmessage(e) {
    let host = window.location.href;
    let ifchat = false
    if (host.indexOf('/chat_page/chat') != -1) {
        ifchat = true
    }
    errsum = 0
    let msg = JSON.parse(e.data)
    let msgType = msg.msgType
    let msgdata = msg.msgContent ? JSON.parse(msg.msgContent) : '';
    let ischat = store.state.im.chatstate;
    let historymsg = {...store.state.im.selectfriend}
    let chatlistarr = store.state.im.chatdata;

    if (msgType != 'HEART_BEAT_RESP') {
        console.log('数据接收', msg)
    }
    switch (msgType) {
        //'获取token'
        case "DEVICE_AUTH_RESP":
            token = msgdata.token;
            break
            // 心跳更新token
        case "HEART_BEAT_RESP":
            token = msgdata.token;
            break
            // 接收到好友消息
        case "WEB_SYNC_CHAT_RECORD":
            let teamflag = teamtip(msgdata.concatInfo.wechatid)
            if (!ifchat || !teamflag) {
                return false
            }
            //获取当前聊天好友的信息和聊天记录
            let oldArr = {...chatlistarr};
            console.log(oldArr,'oldArr103')
            console.log('收到消息:', oldArr, msgdata)
            let addtofrist = {};
            if (oldArr) {
                let top = false
                let n = 0 // 列表好友index
                let nn = 0 // 置顶好友数量
                for (let i = 0; i < oldArr.records.length; i++) {
                    if (oldArr.records[i].top){
                        nn = nn + 1
                    }
                    if (oldArr.records[i].friendid == msgdata.concatInfo.friendid && oldArr.records[i].wechatid == msgdata.concatInfo.wechatid) {
                        top = oldArr.records[i].top
                        n = i
                        addtofrist = {...oldArr.records[i]} //同步消息
                    }
                }
               
                console.log(addtofrist, 'addtofrist',top,ischat)
                // 收到非置顶好友数组为空新建聊天好友
                if (JSON.stringify(addtofrist) == "{}" && !top) {
                    let newtofrist = '';
                    let newArr = store.state.im.chatdata;
                    for (let j = 0; j < newArr.records.length; j++) {
                        newtofrist = ''
                        if (newArr.records[j].friendid == msgdata.concatInfo.friendid && newArr.records[j].wechatid ==
                            msgdata.concatInfo.wechatid) {
                            newtofrist = newArr.records[j]
                            newArr.records.splice(j, 1); // 如果数据组存在该元素，则把该元素删除
                            break;
                        }
                    }
                    if (newtofrist == '') {
                        newtofrist = msgdata.concatInfo
                    }
                    console.log('这个果是新建聊天好友',newtofrist)
                    //查看记录状态新消息提示
                    newtofrist.unReadCount = 1;
                    oldArr.records.splice(n,1); // 如果数据组存在该元素，则把该元素删除
                    oldArr.records.splice(nn,0,newtofrist); // 添加到第一个位置
                    store.commit('im/SELECTCHAT', newArr)
                    console.log(store.state.im.chatdata, 'store.state.im.chatdata', newArr)
                    
                } else {
                    if (historymsg.wechatContactinfo.friendid == msgdata.concatInfo.friendid && historymsg.wechatContactinfo.wechatid == msgdata
                        .concatInfo.wechatid) {
                        //如果是当前聊天好友聊天状态
                        if (ischat) {
                            //获取当前聊天好友的信息和聊天记录
                            let isnewmsg = true;
                            if (historymsg.wechatMessage.data.length != 0) {
                                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                                    if (msgdata.message && historymsg.wechatMessage.data[i].id == msgdata.message.id) {
                                        historymsg.wechatMessage.data[i].createTime = timestampToTime(msgdata.message.createTime)

                                        historymsg.wechatMessage.data[i].sendStatus = msgdata.message.sendStatus
                                        //更新好友聊天信息
                                        console.log('发现', historymsg.wechatMessage.data[i])
                                        store.commit('im/SELECTFRIEND', historymsg)
                                        //触发消息更新
                                        store.commit('im/MSGID', Math.random())
                                        isnewmsg = false
                                        break;
                                    }
                                    if (msgdata.withdrawId && historymsg.wechatMessage.data[i].id == msgdata.withdrawId) {
                                        historymsg.wechatMessage.data[i].contentType = msgdata.msgdata.contentType
                                        historymsg.wechatMessage.data[i].content = msgdata.msgdata.content
                                        store.commit('im/SELECTFRIEND', historymsg)
                                        store.commit('im/MSGID', Math.random())
                                    }
                                }
                            }

                            if (isnewmsg && !msgdata.withdrawId) {
                                //更新好友聊天信息
                                let obj = msgdata.concatInfo
                                Object.assign(obj,msgdata.message)
                                obj.createTime =  timestampToTime(msgdata.message.createTime)
                                historymsg.wechatMessage.data.push(obj)
                                console.log(historymsg, msgdata)
                                store.commit('im/SELECTFRIEND', historymsg)
                                //触发消息更新
                                store.commit('im/MSGID', Math.random())
                            }
                        } else {
                            //查看记录状态新消息提示
                            if (msgdata.message.isSend == "false") {
                                addtofrist.unReadCount++
                            }
                        }

                    } else {
                        //其他好友新消息提示
                        if (msgdata.message.isSend == "false") {
                            addtofrist.unReadCount++
                        }
                    }
                    addtofrist.content = msgdata.message.content
                    addtofrist.contentType = msgdata.message.contentType
                    addtofrist.contactTime = msgdata.message.createTime
                    addtofrist.sendStatus = msgdata.message.sendStatus //设置发送中状态
                    oldArr.records.splice(n,1); // 如果数据组存在该元素，则把该元素删除
                    if(top){
                        addtofrist.top = 1
                        oldArr.records.splice(0,0,addtofrist); 
                    }else{
                        addtofrist.top = 0
                        oldArr.records.splice(nn,0,addtofrist); // 添加到第nn个位置
                    }
                    console.log(oldArr,top,'同步',nn)
                    store.commit('im/SELECTCHAT', oldArr)
                }

            }
            break
        case "WEB_OBTAIN_FRIEND_VIDEO_TASK":
            //图片回执
            if (!ifchat) {
                return false
            }
            // msgdata.content = base64.b64DecodeUnicode(msgdata.content)
            console.log('资源获取完毕', msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (historymsg.wechatMessage.data.length != 0) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].id == msgdata.id) {
                        historymsg.wechatMessage.data[i].content = msgdata.content
                        historymsg.wechatMessage.data[i].sendStatus = '2'
                        //更新好友聊天信息
                        store.commit('im/SELECTFRIEND', historymsg)
                        //触发消息更新
                        store.commit('im/MSGID', Math.random())
                        break;
                    }
                }
            }
            break
        case "WEB_OBTAIN_FRIEND_AUDIO_TASK":
            //消息回执
            if (!ifchat) {
                return false
            }
            // msgdata.content = base64.b64DecodeUnicode(msgdata.content)
            console.log('音频转换完毕', msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (historymsg.wechatMessage.data.length != 0) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].id == msgdata.id) {
                        historymsg.wechatMessage.data[i].content = msgdata.content
                        historymsg.wechatMessage.data[i].loading = false
                        //更新好友聊天信息
                        store.commit('im/SELECTFRIEND', historymsg)
                        //触发消息更新
                        store.commit('im/MSGID', Math.random())
                        break;
                    }
                }
            }
            break
        case "WEB_TALK_TASK_RESULT":
            //消息回执
            if (!ifchat) {
                return false
            }
            let id = msgdata.id;
            console.log('WEB_TALK_TASK_RESULT', msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (ischat) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].id == id) {
                        historymsg.wechatMessage.data[i].sendStatus = msgdata.isSuccess
                    }
                }
                console.log(historymsg, 'SETSELECTFIENDWEB_TALK_TASK_RESULT')
                store.commit('im/SELECTFRIEND', historymsg)
            }

            break
        case "WEB_FRIEND_BE_NOT_IN":
            //设备不在线
            if (!ifchat) {
                return false
            }
            let notinid = msgdata.id;
            console.log('WEB_FRIEND_BE_NOT_IN', msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (ischat) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].id == notinid) {
                        historymsg.wechatMessage.data[i].sendStatus = 3
                    }
                }
                ElementUI.Message.error('设备不在线')
                console.log(historymsg, 'SETSELECTFIENDWEB_TALK_TASK_RESULT')
                store.commit('im/SELECTFRIEND', historymsg)
                // store.commit('im/MSGID', Math.random())
            }

            break
        case "DEVICE_FRIEND_BE_DELETED":
            //好友被删除
            if (!ifchat) {
                return false
            }
            let msgSvrId = msgdata.msgSvrId;
            console.log('DEVICE_FRIEND_BE_DELETED', msgdata)
            //获取当前聊天好友的信息和聊天记录
            for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                if (historymsg.wechatMessage.data[i].msgSvrId == msgSvrId) {
                    historymsg.wechatMessage.data[i].sendStatus = 3
                }
            }
            ElementUI.Message.error('此微信所在的设备不在线,请连接后再试')
            console.log(historymsg, 'SETSELECTFIENDWEB_TALK_TASK_RESULT')
            store.commit('im/SELECTFRIEND', historymsg)
            store.commit('im/MSGID', Math.random())
            break
        case "TAKE_MONEY_TASK":
            //消息id
            if (!ifchat) {
                return false
            }
            let reddata = store.state.im.reddata;
            let redid = msgdata.taskId;
            console.log('TAKE_MONEY_TASK', reddata, msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (ischat && msgdata.content != undefined) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].sendUuid && historymsg.wechatMessage.data[i].id == msgid) {
                        historymsg.wechatMessage.data[i].content = msgdata.content
                    }
                }
                reddata.content = msgdata.content
                store.commit('im/SETRED', reddata)
                store.commit('im/SELECTFRIEND', historymsg)
                // store.commit('im/MSGID', Math.random())
            }
            console.log('TAKE_MONEY_TASK', reddata, historymsg)
            break
        case "GET_WECHAT_RECORD_DETAILS_TASK":
            //消息id
            if (!ifchat) {
                return false
            }
            let detailid = msgdata.id;
            //获取当前聊天好友的信息和聊天记录
            if (ischat) {
                let content = msgdata.content
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].id && historymsg.wechatMessage.data[i].id == detailid) {
                        console.log('TAKE_MONEY_TASK121', historymsg.wechatMessage.data[i])
                        
                        if(msgdata.contentType == 8){
                            historymsg.wechatMessage.data[i].content = content
                        }else{
                            content = JSON.parse(content)
                            content.LinkUrl = JSON.parse(msgdata.content).LinkUrl
                            historymsg.wechatMessage.data[i].content = JSON.stringify(content)
                        }
                        historymsg.wechatMessage.data[i].loading = false
                        console.log('TAKE_MONEY_TASK121', historymsg.wechatMessage.data[i])
                    }
                }
                store.commit('im/SELECTFRIEND', historymsg)
            }
            break
        case "TALK_TO_FRIEND_RESP":
            //消息id
            if (!ifchat) {
                return false
            }
            let msgid = msgdata.sendUuid;
            console.log('TALK_TO_FRIEND_RESP', msgdata)
            //获取当前聊天好友的信息和聊天记录
            if (ischat) {
                for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                    if (historymsg.wechatMessage.data[i].sendUuid && historymsg.wechatMessage.data[i].sendUuid == msgid) {
                        historymsg.wechatMessage.data[i].id = msgdata.id
                    }
                }
                store.commit('im/SELECTFRIEND', historymsg)
                store.commit('im/MSGID', Math.random())
            }

            break
        case "CLEAR_CHAT_UNREAD_NUMBER":
            //消息id
            if (!ifchat) {
                return false
            }
            let cwid = msgdata.weChatId;
            let cfid = msgdata.friendId;
            console.log('CLEAR_CHAT_UNREAD_NUMBER', msgdata)
            //获取当前聊天好友的信息和聊天记录
            let coldArr = chatlistarr;
            console.log(chatlistarr, 'historymsg.wechatMessage.data', cwid, cfid)
            for (let i = 0; i < coldArr.records.length; i++) {
                if (coldArr.records[i].friendid == cfid && coldArr.records[i].wechatid == cwid) {
                    coldArr.records[i].unReadCount = 0
                }
            }
            store.commit('im/SELECTCHAT', coldArr)
            break
        case "FRIEND_DELETE_DEVICE":
            //消息id
            if (!ifchat) {
                return false
            }
            let deleteid = msgdata.msgSvrId;
            console.log('FRIEND_DELETE_DEVICE', msgdata)
            //对方不是好友
            for (let i = 0; i < historymsg.wechatMessage.data.length; i++) {
                if (historymsg.wechatMessage.data[i].msgSvrId == deleteid) {
                    historymsg.wechatMessage.data[i].sendStatus = 3
                }
            }
            ElementUI.Message.error('发送失败，对方还不是你的好友')
            console.log(historymsg, 'FRIEND_DELETE_DEVICE')
            store.commit('im/SELECTFRIEND', historymsg)
            store.commit('im/MSGID', Math.random())
            break
        default:
            break
    }
}

// 分组消息提示
function teamtip(wid){
    let teamarr = [...store.state.im.teamarr];
    const teamid = store.state.im.activeTeam.activeindex;
    let inteam = false
    let flag= false //是否追加新消息
    let index = 0
    teamarr.forEach((v,i) => {
        if(v.activeindex == wid){
            // v.hasnew = true
            index = i
            inteam = true
        }
    });
    console.log('分组：',teamid,inteam,wid)
    if(teamid == 0){
        if(!inteam){
            // 在全部分组收到公共分组消息
            if(teamarr[teamarr.length-1].activeindex == 2){
                teamarr[teamarr.length-1].hasnew = true
            }
        }else{
            teamarr[index].hasnew = true
        }
        flag = true
    }else if(teamid == 2){
        // 在公共分组收到消息
        teamarr[0].hasnew = true
        if(!inteam){
            flag = true
        }else {
            teamarr[index].hasnew = true
            flag = false
        }
    }else{
        // 在私人分组收到消息
        teamarr[0].hasnew = true
        if(!inteam){
            // 在私人分组收到公共分组消息
            if(teamarr[teamarr.length-1].activeindex == 2){
                teamarr[teamarr.length-1].hasnew = true
            }
            flag = false
        }else{
            flag = true
        }
    }
    console.log(teamarr,'分组状态')
    store.commit('im/SETTEAMLIST', teamarr)
    return flag
}

// 数据发送
function websocketsend(agentData) {
    let historymsg = store.state.im.selectfriend

    switch (agentData.msgType) {
        // 发送消息转码
        case "TALK_TO_FRIEND_REQ":
            if (agentData.msgContent.sendStatus == 3) {
                return false
            }
            // let txtcon = base64.b64DecodeUnicode(agentData.msgContent.content)msgSvrId
            let txtcon = agentData.msgContent.content
            historymsg.wechatMessage.data.push({
                content: txtcon,
                sendStatus: agentData.msgContent.sendStatus, //设置发送中状态
                isSend: 'true',
                weChatId: agentData.msgContent.weChatId,
                friendId: agentData.msgContent.friendId,
                contentType: agentData.msgContent.contentType,
                sendUuid: agentData.msgContent.sendUuid
            })
            console.log(historymsg,agentData)
            store.commit('im/SELECTFRIEND', historymsg)
            break
        default:
            break
    }
    if (agentData.msgContent) {
        if (agentData.msgContent.sendStatus == 3) {
            return false
        } else {
            delete agentData.msgContent.sendStatus
        }

    }
    console.log(agentData,'agentData')
    websock.send(JSON.stringify(agentData))
}

// 关闭
function websocketclose(bool) {
    console.log('websocket 连接关闭')
    clearInterval(socktimer) //关闭连接终止定时器
    if (errsum < 10 && bool) {
        console.log(errsum)
        errsum++;
        console.log('WebSocket断开，第' + errsum + '次重新连接')
        // ElementUI.Message.error('WebSocket断开，第' + errsum + '次重新连接')
        setTimeout(function() {
            initWebSocket()
        }, errsum * 1000)
    } else {
        ElementUI.Message.error('WebSocket连接失败')
    }
    // store.dispatch('SetError', '与服务器断开连接！')
    //设置websocket关闭状态
    store.commit('im/SOCKETSTATE', false)
}

function websocketOpen() {

    //获取长连接token
    gettoken();
    socktimer = setInterval(() => {
        sendSock({
            msgType: 'HEART_BEAT_REQ',
            msgContent: {
                token: token,
                check: "web"
            }
        })
        let t = new Date();
    }, 30000)
    //设置websocket开启状态
    store.commit('im/SOCKETSTATE', true)
}

//获取token
function gettoken() {
    let imtoken = localStorage.getItem('token')
    console.log(imtoken, '获取长链接token')
    if (imtoken) {
        let gettokendata = {
            msgType: 'DEVICE_AUTH_REQ',
            msgContent: imtoken
        }

        sendSock(gettokendata)
    }
}

export {
    sendSock,
    initWebSocket
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js